import React from "react";
import Stack from "@mui/material/Stack";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import Typography from "@mui/material/Typography";
import PersonIcon from '@mui/icons-material/Person';
import styled from "@emotion/styled";


export const PeopleTag = ({peopleNumber={}, iconSize="medium", variant="outlined"}) => {
    return (
        <Stack direction="row" alignItems="center">
            {
                variant === "outlined" && <PersonOutlineIcon fontSize={iconSize}/>
            }
            {
                variant === "contained" && <PersonIcon fontSize={iconSize}/>
            }
            <Typography variant="body2" noWrap> x {peopleNumber}</Typography>
        </Stack>
    )
}

export const TextTag = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

export const PriceTag = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-weight: 600;
  font-size: 12px;
  position: relative;
`

export const StatusTag = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 10px;
  background-color: ${props => props.enabled === false ? "rgba(211, 47, 47, 0.2)" : "transparent"};
`

export const CircleCssIcon = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.enabled === false ? props.theme.palette.error.main : props.theme.palette.success.main};
`